import React, { ReactNode, useMemo } from 'react';
import { ThemeProvider, Theme } from '@emotion/react';
import { theme } from 'ech-components/src/core/styles/theme';
import GlobalStyles from 'ech-components/src/core/styles/GlobalStyles';
import EchCookieBanner from '../EchCookieBanner';
import { useWindowSize } from 'ech-components/src/core/utils/Hooks';
import getStylesExtension from 'ech-components/src/core/styles/stylesExtension';

const Layout = ({
  children,
  customTheme,
  disableCookieBanner,
}: LayoutProps) => {
  const { height }: { height?: number } = useWindowSize();

  if (height) document.body.style.setProperty('--100vh', `${height}px`);

  return useMemo(() => {
    const globalTheme: Theme = {
      ...theme,
      ...customTheme,
      ...getStylesExtension(customTheme?.campaign?.key),
    };

    return (
      <ThemeProvider theme={globalTheme}>
        <GlobalStyles />
        {children}
        {!disableCookieBanner && <EchCookieBanner />}
      </ThemeProvider>
    );
  }, [children, customTheme, disableCookieBanner]);
};

export type LayoutProps = {
  children: ReactNode;
  disableCookieBanner?: boolean;
  customTheme?: {
    campaign?: Record<string, string>;
  };
};

export default Layout;
